import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setServiceUrl,
} from '@library/http/requests'
import { extractCoreData } from '@library/http/src/parsers'

const fetchMotivations = composeFetch(
  composeRequest(setServiceUrl('core'), addPath('motivations'), setMethod('GET'), goustoHeaders),
  extractCoreData(),
)

export { fetchMotivations }
